'use client';

import { cookieStorage } from '@/services/cookie';
import useIsAdmin from '@/hooks/useIsAdmin';
import { apiClient } from '@/services/base';
import { useEffect } from 'react';

const SellerCartButton = () => {
  const { isAdmin } = useIsAdmin();

  const setSellerId = async () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const sellerIdParam = params.get('sid');
    if (sellerIdParam) {
      await cookieStorage.put({ key: 'sid', value: sellerIdParam });
    }
  };

  useEffect(() => {
    setSellerId();
  }, []);

  const onCopySellerUrl = async () => {
    try {
      const sellerId = await apiClient.get(`/user/id`, {
        credentials: 'include',
        headers: {
          Cookie: document.cookie,
        },
      });
      const json: string = (await sellerId.json()) || '';
      const urlObject = new URL(window.location.href);
      urlObject.searchParams.set('sid', json);
      const ursWithSellerId = urlObject.toString();
      await navigator.clipboard.writeText(ursWithSellerId);
      await cookieStorage.put({ key: 'sid', value: json || '' });
      alert(`Copied to clipboard : ${urlObject}`);
    } catch (error) {
      console.error('cant copy seller id to clipboard', error);
    }
  };

  return (
    isAdmin && (
      <span data-testid="seller-cart-button" onClick={onCopySellerUrl} className={'icon icon-share'}>
        <img alt="seller logo" src="https://www.pyramydair.com/images/email/share-icon.png" />
      </span>
    )
  );
};

export default SellerCartButton;
